import i18n from '@/i18n';
import store from '@/store';
import H_checklist from '@/helpers/checklist';

export default {
  setIndexData(rawDataList, scopeUpdate) {
    return rawDataList.map(rawData => {
      const {id, name, sequence, common_choices, risk_level} = rawData;
      const title = {
        name,
        risk: risk_level ? `(${H_checklist.setRiskLevelText(risk_level)})` : '',
      };
      const subChoices = common_choices && common_choices.length
        ? common_choices.map(choice => {
            const {name, risk_level} = choice;
            const tarRiskLevelText = H_checklist.setRiskLevelText(risk_level);
            return {name, risk: `(${tarRiskLevelText})`};
          })
        : i18n.t('無');
      let result = {
        id,
        title,
        sequence,
        subChoices,
      };
      if (scopeUpdate) {
        result = {
          ...result,
          edit: {
            icon: 'icon-edit',
            color: 'blue',
          },
          copy: {
            icon: 'icon-copy',
            color: 'blue',
          },
          remove: {
            icon: 'icon-delete',
            color: 'red',
          },
        }
      }
      return result;
    })
  },
  setSubmitData(rawData) {
    const factory = store.state.app.factory.id;
    const {
      title: name,
      hasSubOption,
      requiredRemark,
      risk: risk_level,
      subOptionList,
    } = rawData;
    let result = {
      name,
      factory,
      has_child: hasSubOption  ? 1 : 0,
      has_remark:  0,
      risk_level: null,
      common_choices: [],
    };
    if (hasSubOption) {
      result.common_choices = subOptionList.map(subOption => {
        const {id, requiredRemark, risk: risk_level, title} = subOption;
        return {
          id,
          name: title,
          factory,
          has_child: 0,
          has_remark: requiredRemark ? 1 : 0,
          risk_level,
        };
      });
    } else {
      result = {
        ...result,
        has_remark: requiredRemark ? 1 : 0,
        risk_level,
      };
    }
    return result;
  },
  setUpdateData(rawData, isCopy=false) {
    const {
      id,
      name,
      has_remark,
      has_child,
      risk_level,
      common_choices
    } = rawData;
    let result = {
      id: isCopy ? null : id,
      title: isCopy ? `${name}-複製` : name,
      requiredRemark: has_remark === 1,
      hasSubOption: has_child === 1,
      risk: risk_level != null ? `${risk_level}` : null,
      subOptionList: [],
      isCopy,
    };
    if (has_child) {
      const subOptionList = common_choices.map(rawSubData => {
        const {has_remark, id, name, risk_level} = rawSubData;
        return {
          id: isCopy ? null : id,
          title: isCopy ? `${name}-複製` : name,
          requiredRemark: has_remark === 1,
          risk: risk_level != null ? `${risk_level}` : null,
        };
      });
      result = {
        ...result,
        subOptionList,
      };
    }
    return result;
  },
  setSortingList(rawDataList) {
    return rawDataList.map(rawData => {
      return this.setUpdateData(rawData);
    });
  },
  setSubmitSortingList(rawDataList) {
    const sortList = rawDataList.map(rawData => {
      const item =  {id: rawData.id};
      if (rawData.hasSubOption && rawData.subOptionList.length) {
        item.order = rawData.subOptionList.map(subOption =>{return {id: subOption.id}});
      }
      return item;
    })
    return {
      order: sortList,
      factory: store.state.app.factory.id,
    }
  },
  setOptionList(rawDataList) {
    return rawDataList.map(rawData => {
      const {
        id: commonChoiceId,
        name: title,
        has_remark,
        has_child,
        risk_level,
        common_choices
      } = rawData;
      let result = {
        commonChoiceId,
        title,
        requiredRemark: has_remark === 1,
        hasSubOption: has_child === 1,
        risk: risk_level != null ? `${risk_level}` : null,
        subOptionList: [],
      };
      if (has_child) {
        const subOptionList = common_choices.map(rawSubData => {
          const {has_remark, id: commonChoiceId, name: title, risk_level} = rawSubData;
          return {
            commonChoiceId,
            title,
            requiredRemark: has_remark === 1,
            risk: risk_level != null ? `${risk_level}` : null,
          };
        });
        result = {
          ...result,
          subOptionList,
        };
      }
      return result;
    });
  }
}